<template>
  <div class="setSheetCompute">
    <div class="contentItem">
      <div class="itemTitle">
        选择运算对象
        <span class="require-flag">*</span>
      </div>
      <div class="titleTip" style="margin-bottom: 10px">当前流程中可运算的批量数据</div>
      <tree-select
        :group-list="computeTargets"
        v-model="tempNodeData.varName"
        @input="changeExtra"
      ></tree-select>
    </div>
    <div class="contentItem">
      <div class="itemTitle">
        选择运算字段
        <span class="require-flag">*</span>
      </div>
      <div v-if="!tempNodeData.varName" class="titleTip" style="margin-bottom: 10px">
        必须先指定一个运算对象后，才能选择运算字段
      </div>
      <div v-else class="titleTip" style="margin-bottom: 10px">
        当前选择的批量数据所选择的字段
      </div>
      <NormalSelect
        v-if="tempNodeData.varName"
        size="normal"
        :selectList="viewFields"
        :selectedItem.sync="tempNodeData.cid"
        @update:selectedItem="changeExtra"
      ></NormalSelect>
    </div>
    <div class="contentItem">
      <div class="itemTitle" style="margin-bottom: 10px; margin-top: 10px">
        选择运算方法
        <span class="require-flag">*</span>
      </div>
      <NormalSelect
        :selectList="computedMethods"
        size="normal"
        :selectedItem.sync="tempNodeData.method"
        @update:selectedItem="changeExtra"
      ></NormalSelect>
    </div>
  </div>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { deepClone } from "@/utils/common"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { filterTreeVarGroup, transOldExpr } from "@/utils/workFlow"
import { bfs } from "@/utils/algorithm"
export default {
  name: "setSheetCompute",
  components: {
    TreeSelect,
    NormalSelect
  },
  inject: ["workflowType"],
  props: {
    workflowVarGroup: Array,
    nodeData: Object,
    extra: Object,
    availableSheets: Array
  },
  data() {
    return {
      tempNodeData: {},
      computedMethods: [
        {
          label: "计数",
          value: "count"
        },
        {
          label: "求和",
          value: "sum"
        },
        {
          label: "最小值",
          value: "min"
        },
        {
          label: "最大值",
          value: "max"
        }
      ]
    }
  },
  computed: {
    computeTargets() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        // deep == 0 表示此时的值是个id数组,不能参与计算
        filterFunc: ({ control }) => control._type === "ref" && !control.oneFlag && control.deep > 0
      })
    },
    varSheetMap() {
      let sheetMap = this._.keyBy(
        this.availableSheets.flatMap(r => r.sheets),
        "sheetId"
      )
      let map = {}
      bfs({
        arr: this.computeTargets,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => {
            map[option.value] = sheetMap[option.control.refSheetId]
          })
        }
      })
      return map
    },
    viewFields() {
      let sheet = this.varSheetMap[this.tempNodeData.varName]
      return (sheet?.controls || []).map(control => ({
        label: control.name,
        value: control._cid
      }))
    }
  },
  created() {
    this.tempNodeData = deepClone(this.nodeData)
    this.tempNodeData.varName = transOldExpr(this.tempNodeData.varName)
  },
  methods: {
    changeExtra() {
      if (this.tempNodeData.cid && this.tempNodeData.method && this.tempNodeData.varName) {
        let controlName = this.viewFields.find(v => v.value === this.tempNodeData.cid).label
        let methodName = this.computedMethods.find(m => m.value === this.tempNodeData.method)?.label
        let sheetName = this.varSheetMap[this.tempNodeData.varName].name
        this.$set(this.extra, "description", {
          sheetName: sheetName,
          expression: controlName + " " + methodName
        })
      }
    }
  }
}
</script>
